@if (client$ | async; as client) {
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>Users</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
                <h4>Seats</h4>
                @if (client.is_paid) {
                    <p>
                        This is the number of seats you are being billed for and how many active
                        users occupying a seat
                    </p>
                } @else {
                    <p>For the Free plan, you're allocated {{ client.member_quota }} users</p>
                }
                <span>{{ client.paid_members }} / {{ client.member_quota }}</span>
                <mat-progress-bar
                    mode="determinate"
                    [value]="(client.paid_members / client.member_quota) * 100"
                ></mat-progress-bar>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <frog-invite-users-button></frog-invite-users-button>
            <button mat-stroked-button [routerLink]="['/a/billing']" color="primary">View</button>
        </mat-card-actions>
    </mat-card>
}
